import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography, } from "@mui/material";
import { AudioCallsIcon, AvgMessagesPerIcon, TotalChatsIcon, VideoCallsIcon } from "../../../icons";
import ReplyRateCard from "./ReplyRateCard";
import { useSelector } from "react-redux";
import { fetchCommunicationActivity } from "../../../api/nystats";

export default function CommunicationActivityHub() {
	const filter = useSelector((state) => state.filter);
	const filterWithoutUTM = useMemo(() => {
		const { utm_options, ...rest } = filter;
		return rest;
	}, [JSON.stringify(filter)]);
	const [communicationActivity, setCommunicationActivity] = useState({});
	const [isLoading, setIsLoading] = useState(true);

	const fetchData = async () => {
		try {
			setIsLoading(true);
			const data = await fetchCommunicationActivity(filter);
			setCommunicationActivity(data ?? {});
		} catch (err) {
			console.error("Error while loading New York revenue data", err);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [JSON.stringify(filterWithoutUTM)]);

	const formatTimeFromMinutes = (minutes) => {
		if (minutes == null || minutes < 0) return "N/A";

		if (minutes < 60) {
			return `${minutes} min`;
		}

		const hours = Math.floor(minutes / 60);
		if (hours < 24) {
			return `${hours} hr${hours > 1 ? "s" : ""}`;
		}

		const days = Math.floor(hours / 24);
		return `${days} day${days > 1 ? "s" : ""}`;
	};



	return (
		<Box sx={{ boxShadow: 'none', border: '1px solid #e6e6e6', borderRadius: '20px', p: 2 }}>
			{/* Title */}
			<Typography sx={{ fontSize: '20px', color: '#3C4043', borderLeft: '3px solid #FBBF24', paddingLeft: '10px', mb: 3, fontWeight: '500', }}>
				Communication Activity Hub
			</Typography>
			{
				isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
					<Typography variant="body1" color="text.secondary">
						Loading...
					</Typography>
				</Box>
					: <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', gap: 2 }}>
						<Box sx={{ width: '100%', border: '1px solid #e6e6e6', p: 2, borderRadius: '10px', flex: 1, }}>
							<Typography sx={{ fontSize: '16px', color: '#101828', }}>Messaging Metrics</Typography>
							<Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', borderBottom: '1px solid #e6e6e6', py: 3, mb: 3 }}>
								<Box sx={{ display: 'flex', alignItems: 'start', gap: 1, }}>
									<TotalChatsIcon />
									<Box>
										<Typography sx={{ color: "#6A7282", fontSize: '14px', }}>Total Chats Initiated</Typography>
										<Typography sx={{ color: "#101828", fontSize: '16px', }}>{communicationActivity?.totalChatsInitiated}</Typography>
									</Box>
								</Box>
								<Box sx={{ display: 'flex', alignItems: 'start', gap: 1, }}>
									<AvgMessagesPerIcon />
									<Box>
										<Typography sx={{ color: "#6A7282", fontSize: '14px', }}>Avg Messages per Active User</Typography>
										<Typography sx={{ color: "#101828", fontSize: '16px', }}>{communicationActivity?.avgMessagesPerUser}</Typography>
									</Box>
								</Box>
							</Box>
							<ReplyRateCard replyRate={communicationActivity?.replyRate} firstReplyTime={`${formatTimeFromMinutes(communicationActivity?.firstReplyInMin)} (Avg)`} />
							{/* <Box textAlign="center" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', justifyContent: 'center', alignItems: 'center', my: 4 }}>
								<Typography sx={{ color: "#6A7282", fontSize: '14px', }}>
								  Initiators  <Typography variant="span" sx={{ display: 'block', color: '#101828', fontSize: '16px' }}>{communicationActivity?.initiatorPercentage}%</Typography>
							  </Typography>
								<Typography sx={{ color: "#6A7282", fontSize: '14px', borderLeft: '1px solid #ccc', }}>
									Responders  <Typography variant="span" sx={{ display: 'block', color: '#101828', fontSize: '16px' }}>{communicationActivity?.responderPercentage}%</Typography>
								</Typography>
							</Box> */}
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
								<Typography sx={{ color: "#000", fontSize: '14px', }}>
									Behavior Indicators
									{/* <Typography variant="span" sx={{color:'#6A7282', fontSize:'14px'}}>(Most Messaged Users (24h))</Typography> */}
								</Typography>
								{
									communicationActivity?.mostMsgUsers?.map(user => <Typography sx={{ color: "#6A7282", fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
										User #{user?.firstName ?? user?.userName}  <Typography variant="span" sx={{ color: '#6A7282', fontSize: '14px' }}>{user?.msgCount} msgs</Typography>
									</Typography>)
								}
							</Box>
						</Box>

						<Box sx={{ width: '100%', border: '1px solid #e6e6e6', p: 2, borderRadius: '10px', flex: 1, }}>
							<Typography sx={{ fontSize: '16px', color: '#101828', }}>Calls Metrics</Typography>
							<Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)', borderBottom: '1px solid #e6e6e6', gap: 3, py: 3, mb: 3 }}>
								<Box sx={{ display: 'flex', alignItems: 'start', gap: 1, }}>
									<AudioCallsIcon />
									<Box>
										<Typography sx={{ color: "#6A7282", fontSize: '14px', }}>Voice Calls Made</Typography>
										<Typography sx={{ color: "#101828", fontSize: '16px', }}>{communicationActivity?.callMetrics?.audioCall}</Typography>
									</Box>
								</Box>
								<Box sx={{ display: 'flex', alignItems: 'start', gap: 1, }}>
									<VideoCallsIcon />
									<Box>
										<Typography sx={{ color: "#6A7282", fontSize: '14px', }}>Video Calls Made</Typography>
										<Typography sx={{ color: "#101828", fontSize: '16px', }}>{communicationActivity?.callMetrics?.videoCall}</Typography>
									</Box>
								</Box>
							</Box>
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
								{/* <Typography sx={{color:"#6A7282", fontSize:'14px', display:'flex', justifyContent:'space-between', alignItems:'center'}}> 
			Avg Call Duration <Typography variant="span" sx={{ color:'#6A7282', fontSize:'14px'}}>8m 42s</Typography>
		</Typography> */}
								<Typography sx={{ color: "#6A7282", fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									Successful Calls  <Typography variant="span" sx={{ color: '#00A63E', fontSize: '14px' }}>{communicationActivity?.callMetrics?.successCall?.percentage}%</Typography>
								</Typography>
								<Typography sx={{ color: "#6A7282", fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									Failed Attempts  <Typography variant="span" sx={{ color: '#E7000B', fontSize: '14px' }}>{communicationActivity?.callMetrics?.failedCall?.percentage}%</Typography>
								</Typography>
							</Box>
						</Box>
					</Box>
			}
		</Box>
	);
}
